export default "__VITE_ASSET__EeD7zSwf__"